import styled, { css } from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing, { spacingWithBorder } from '../../../helpers/spacing';
import Icon from '../../Icon';
import Image from '../../Image';
import LazyImg from '../../LazyImg';
import Link from '../../Link';
import RichText from '../../RichText';

const borderPx = 1;

type InfoCardContainerProps = {
  displayBackground?: boolean;
  alignLeft?: boolean;
  hasImage?: boolean;
};

export const InfoCardWrapper = styled.div`
  border: ${borderPx}px solid ${colors.cardBorder};
  margin: ${spacing(1)} 0;

  ${mediaQuery.tabletLandscape`
    margin: ${spacing(2)} 0;
  `}
`;

export const Heading = styled.div<{ alignLeft?: boolean }>`
  ${fonts.headingSmall}
  display: flex;
  ${({ alignLeft }) =>
    !alignLeft &&
    css`
      flex-direction: column;
      align-items: center;
      text-align: center;
    `};

  ${Icon} {
    color: ${colors.cardIcon};
    ${({ alignLeft }) =>
      alignLeft &&
      css`
        margin-right: ${spacing(2)};
      `}
    flex: 0 0 ${spacing(4)};
  }
`;

export const InfoCardRichText = styled(RichText)<{ alignLeft?: boolean }>`
  margin: ${spacing(2)} 0 0;
  ${({ alignLeft }) =>
    !alignLeft &&
    css`
      text-align: center;
    `}
`;

export const CtaWrapper = styled.div`
  margin-top: auto;
  padding-top: ${spacing(4)};
`;

export const LogoImage = styled(LazyImg)`
  align-self: flex-start;
  margin: ${spacing(2)} 0 0;
  max-height: ${spacing(4)};
`;

export const StyledImage = styled(Image)`
  width: 100%;
  height: 148px;
  object-position: 50% 50%;
  object-fit: cover;
`;

export const InfoCardContainer = styled.div<InfoCardContainerProps>`
  display: flex;
  flex-flow: column nowrap;
  background-color: ${({ displayBackground }) =>
    displayBackground ? colors.neutral08 : 'initial'};
  position: ${({ displayBackground }) => (displayBackground ? 'relative' : 'initial')};
  align-items: ${({ alignLeft }) => (alignLeft ? 'flex-start' : 'center')};
  justify-content: space-between;
  height: ${({ hasImage }) => (hasImage ? 'calc(100% - 148px)' : '100%')};

  padding: ${spacingWithBorder(4, borderPx)} ${spacingWithBorder(3, borderPx)};
  border-radius: ${({ theme }) => `${theme.cardRadius}`};

  ${mediaQuery.tabletLandscape`
    padding: ${spacingWithBorder(4, borderPx)};
  `}
`;

export const TextContainer = styled.div<InfoCardContainerProps>`
  display: flex;
  flex-flow: column nowrap;
  position: ${({ displayBackground }) => (displayBackground ? 'relative' : 'initial')};
  align-items: ${({ alignLeft }) => (alignLeft ? 'flex-start' : 'center')};
`;

export const StyledLink = styled(Link)`
  ${fonts.paragraph};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: ${spacing(4)};
  gap: ${spacing(1)};
`;
